module.exports = __webpack_public_path__ + "img/干果3.12f84667.png";